import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/kayaking-banner.png")